import { render, staticRenderFns } from "./FinancialAddAccount.vue?vue&type=template&id=00865475"
import script from "./FinancialAddAccount.vue?vue&type=script&lang=js"
export * from "./FinancialAddAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports